module.exports = __webpack_public_path__ + "img/lingua-ai-logo.46c2e057.png";